function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 30,
  fill: "#2F66E3"
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 26.4,
  stroke: "white",
  strokeWidth: 1.2
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M28.4236 26.58C28.8108 26.6398 29.2019 26.6698 29.5936 26.67C31.4881 26.6637 33.3068 25.9247 34.6686 24.6076C36.0305 23.2905 36.8298 21.4977 36.8994 19.6044C36.969 17.7112 36.3034 15.8644 35.0419 14.4509C33.7804 13.0375 32.0209 12.1669 30.1319 12.0216C28.243 11.8763 26.3711 12.4675 24.9083 13.6714C23.4455 14.8753 22.5052 16.5985 22.2844 18.4802C22.0636 20.3618 22.5794 22.2558 23.7238 23.7657C24.8682 25.2755 26.5524 26.284 28.4236 26.58V26.58ZM25.6486 15.39C26.5211 14.4942 27.6699 13.9184 28.9097 13.7554C30.1495 13.5925 31.4081 13.8518 32.4824 14.4916C33.5568 15.1315 34.3844 16.1145 34.8318 17.2822C35.2791 18.4499 35.3201 19.7343 34.9481 20.9282C34.5762 22.122 33.8131 23.1559 32.7817 23.863C31.7504 24.57 30.5108 24.9091 29.2632 24.8255C28.0155 24.742 26.8324 24.2407 25.9045 23.4024C24.9766 22.5641 24.358 21.4378 24.1486 20.205C23.9981 19.3409 24.0557 18.4535 24.3166 17.6162C24.5774 16.7788 25.034 16.0157 25.6486 15.39V15.39Z",
  fill: "white"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.1476 40.1249C14.9831 40.7069 14.9557 41.3192 15.0675 41.9136C15.1793 42.508 15.4273 43.0685 15.792 43.5509C16.1568 44.0334 16.6284 44.4248 17.1698 44.6944C17.7112 44.9641 18.3078 45.1046 18.9126 45.1049H40.2577C40.8632 45.1022 41.4597 44.9595 42.001 44.6882C42.5423 44.4168 43.0136 44.024 43.3781 43.5405C43.7425 43.0569 43.9903 42.4958 44.1021 41.9007C44.2139 41.3056 44.1867 40.6927 44.0226 40.1099C43.1358 36.9636 41.2456 34.1932 38.6395 32.2201C36.0333 30.2469 32.8539 29.1791 29.5851 29.1791C26.3163 29.1791 23.137 30.2469 20.5308 32.2201C17.9247 34.1932 16.0344 36.9636 15.1476 40.1099V40.1249ZM29.5776 30.9899C32.4486 31.001 35.2387 31.9426 37.5294 33.6734C39.8201 35.4043 41.4879 37.8311 42.2826 40.5899C42.3759 40.9052 42.3944 41.2379 42.3367 41.5615C42.2789 41.8852 42.1465 42.1909 41.9499 42.4544C41.7534 42.718 41.4981 42.932 41.2043 43.0797C40.9106 43.2273 40.5864 43.3044 40.2577 43.3049H18.9126C18.5864 43.3061 18.2645 43.2307 17.9727 43.0848C17.681 42.9389 17.4274 42.7266 17.2326 42.4649C17.0332 42.2037 16.8969 41.8998 16.8345 41.5772C16.772 41.2545 16.7851 40.9217 16.8726 40.6049C17.669 37.8372 19.343 35.403 21.6425 33.6689C23.942 31.9348 26.7426 30.9946 29.6226 30.9899H29.5776Z",
  fill: "white"
});

var _ref6 =
/*#__PURE__*/
React.createElement("rect", {
  x: 43,
  y: 36,
  width: 24,
  height: 24,
  rx: 12,
  fill: "#27AE60"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M49 48L53 52L61 45",
  stroke: "white",
  strokeWidth: 2
});

var SvgActiveProducer = function SvgActiveProducer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 67,
    height: 60,
    viewBox: "0 0 67 60",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgActiveProducer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/active-producer.c92e2d43.svg";
export { ForwardRef as ReactComponent };